(function ($) {
	"use strict";

	function capitalizeWords(str) {
		if (typeof str !== "string") return str;

		return str
			.split(" ")
			.map((word) => {
				if (word.length > 3) {
					return word.charAt(0).toUpperCase() + word.slice(1);
				}
				return word;
			})
			.join(" ");
	}

	var AppPage = function () {
		var o = this;
		$(document).ready(function () {
			o.initialize();
		});
	};

	var p = AppPage.prototype;
	p._tabs = false;
	p._tabsActionId = null;
	p._tabsId = [];
	p._tabsIdView = [];
	p._routesPageId = {};
	p.app = window.gpssat.App;
	p.alert = window.gpssat.AppMessage;
	p.tables = window.gpssat.AppTable;

	p.initialize = function () {
		this._initEventSubmit();
		this._initEventCard();
		this._initRemovePage();
		this._initSelectPage();
		this._initOpenPageSave();
		this._initPageScrollTop();
	};

	p._initTabs = function () {
		var o = this;

		jQuery("#content-page").html("");
		jQuery("#tabs-pages").css("display", "");

		o._tabActive = null;
		o._tabs = true;

		return true;
	};

	p.setContentElementHeight = function () {
		const $content = document.querySelector("#base>#content");
		if (!$content) return;
		const $header = $content.querySelector(".card.tabs-menu.theme-background-color");
		if (!$header) return;
		const $activeTab = $content.querySelector('.tabs-pages[data-content^="tabs-pages"]:not([style*="display: none"])');
		const $footer = $activeTab ? $activeTab.querySelector(".footer.tabs-below") ?? {} : {};
		const headerWidth = $header.offsetHeight ?? 0;
		const footerWidth = $footer.offsetHeight ?? 0;
		$content.style.height = `calc(100dvh - ${headerWidth}px - ${footerWidth}px)`;
	};

	p._initRemovePage = function () {
		var o = this;

		jQuery("#tabs-pages").delegate("[id^=tabs-pages-delete-]", "click", function () {
			var id = jQuery(this).attr("id").replace("delete-", "");
			o.removePage(id);
			return false;
		});
	};

	p.removePage = function (id) {
		var o = this;
		const TAB_ID_PREFIX = "tabs-pages-";
		id = id.startsWith(TAB_ID_PREFIX) ? id : `${TAB_ID_PREFIX}${id}`;
		const pageId = id.replace(TAB_ID_PREFIX, "");
		$("#" + $("#" + id).attr("aria-describedby")).remove();
		$("[data-content=" + id + "]").remove();
		$("[data-content-search=" + id + "]").remove();
		$("a#" + id)
			.parent()
			.remove();

		if ($("#tabs-pages li").length == 0) {
			$("#tabs-pages").css("display", "none");
			o._tabs = false;
		}
		var hashId = id.replace("tabs-pages-", "");
		var tabId = o._tabsId.indexOf(hashId);
		o._tabsId.splice(tabId, 1);

		var tabIdView = o._tabsIdView.indexOf(hashId);
		o._tabsIdView.splice(tabIdView, 1);

		Object.entries(p._routesPageId).forEach(([route, _pageId]) => {
			if (_pageId === pageId) delete p._routesPageId[route];
		});

		var table = window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()];
		if (table) {
			table.splice(table.indexOf(window.gpssat.AppTable._getTableId()), 1);
		}

		function cleanPageTempStorage() {
			delete gpssat.App._functions[hashId];
			delete gpssat.App._variables[hashId];
		}
		if (!gpssat.App._variables[pageId]) gpssat.App._variables[pageId] = [];
		if (!gpssat.App._functions[pageId]) gpssat.App._functions[pageId] = [];
		if (gpssat.App._functions[pageId]) {
			if (!gpssat.App._functions[pageId]["onClose"]) gpssat.App._functions[pageId]["onClose"] = [];
			if (!gpssat.App._functions[pageId]["onChange"]) gpssat.App._functions[pageId]["onChange"] = [];
			if (!gpssat.App._functions[pageId]["refresh"]) gpssat.App._functions[pageId]["refresh"] = [];
		}
		const onClose = gpssat.App._functions[pageId]["onClose"];
		const onClosePromises = onClose.map((onClose) => {
			const output = onClose();
			if (output instanceof Promise) return output;
			return Promise.resolve();
		});
		Promise.all(onClosePromises).then(cleanPageTempStorage);

		o._deletePage(id.replace("tabs-pages-", ""));
		o.toggleTabsScrollOnOverflow();
		gpssat.AppNavigation._ajustBarSetting();

		if (o._tabsId[0] && hashId == o._tabsActionId) {
			if (tabId > 0) {
				tabId = tabId - 1;
			} else {
				tabId = 0;
			}
			o._selectPage("tabs-pages-" + o._tabsId[tabId]);

			const tabWasAlreadyOnTabsList = o._tabsIdView.includes(o._tabsId[tabId]);
			if (tabWasAlreadyOnTabsList) return false;

			let getRoute = $("#tabs-pages .active a").data("route");
			let getPosition = $("#tabs-pages .active a").parent().data("position");
			o._openPageAjax(getRoute, null, getPosition, true);
		}
	};

	p._initSelectPage = function () {
		var o = this;
		jQuery("#tabs-pages").delegate("[id^=tabs-pages-]", "click", function () {
			var idNew = jQuery(this).attr("id");
			if (idNew.indexOf("-delete-") == -1) {
				var idOld = jQuery("#tabs-pages .active a").attr("id");
				var getRoute = $(this).data("route");
				var getPosition = $(this).parent().data("position");
				var pageId = jQuery(this).attr("data-id");

				if (idOld == idNew) {
					return false;
				}

				o._selectPage(idNew, idOld);
				const tabWasAlreadyOnTabsList = o._tabsIdView.includes(pageId);
				if (tabWasAlreadyOnTabsList) return false;

				o._openPageAjax(getRoute, null, getPosition, true);
			}
			return false;
		});
	};

	p._initOpenPageSave = function () {
		var o = this;

		o.app._ajax("GET", window.location.origin + "/users/tools", false, function (data) {
			if (data != null && data.length > 0) {
				o._openPageAjax(data[0].url, null, data[0].x, true);
			}

			for (var i in data) {
				o.openTabs(data[i].x, data[i].url, data[i].key, capitalizeWords(data[i].title));

				//Sleep
				var start = new Date().getTime();
				for (var i = 0; i < 1e7; i++) {
					if (new Date().getTime() - start > 200) {
						break;
					}
				}
			}
		});
	};

	p._initEventSubmit = function () {
		var o = this;
		jQuery("body").delegate("form", "submit", function (e) {
			if (jQuery(this).attr("enctype") == "multipart/form-data") {
				return false;
			}

			o.app._ajax(
				"POST",
				jQuery(this).attr("action"),
				jQuery(this).serialize(),
				function (data) {
					if (typeof data.keepOpen === "undefined") {
						if (data.msg) {
							o.alert._success(data.msg);
						} else {
							o.alert._success(data);
						}
						bootbox.hideAll();
					} else {
						o.alert._success(data.msg);
					}

					if (
						o._validForm() == true &&
						typeof window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()] !== "undefined" &&
						(typeof data.datatableReload === "undefined" || data.datatableReload == true)
					) {
						window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()].ajax.reload();
					}

					if (typeof data.execFunction != "undefined") {
						if (typeof gpssat.App._functions[gpssat.AppPage._tabsActionId][data.execFunction] === "function") {
							gpssat.App._functions[gpssat.AppPage._tabsActionId][data.execFunction]();
						}
					}

					if (data.callback != "undefined") {
						eval(data.callback);
					}
				},
				function (data) {
					if (data.responseJSON) {
						if (data.responseJSON["warning"] || data.responseJSON["msg"]) {
							o.alert._warning(data.responseJSON["msg"]);
							return;
						}

						let msg = "<ul>";
						for (let i in data.responseJSON["errors"]) {
							msg += "<li>" + data.responseJSON["errors"][i] + "</li>";
						}
						msg += "</ul>";
						o.alert._info(msg, "Os seguintes campos devem ser preenchidos:");
					} else {
						o.alert._warning(data.responseText);
					}
				},
			);

			return false;
		});
	};

	p._validForm = function () {
		var fields = jQuery('[data-content-search="tabs-pages-' + gpssat.AppTable._getTableId() + '"]').serializeArray();
		for (var i in fields) {
			if (fields[i].value.length > 0) {
				return true;
			}
		}

		return false;
	};

	p._initEventCard = function () {
		var o = this;

		o._eventAdd();
		o._eventEdit();
		o._eventDelete();
		o._eventGeneric();
		o._eventRefresh();
		o._eventCollapse();
		o._eventOpenPage();
		o._eventMenu();
	};

	p._eventAdd = function () {
		jQuery("body").delegate("[id=btn-add]", "click", function () {
			var route = jQuery(this).attr("data-route");
			if (route) {
				p._renderModal(route);
			}
		});
	};

	p._eventEdit = function () {
		var o = this;
		jQuery("body").delegate("[id=btn-edit]", "click", function () {
			var row = window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()].row(".selected").data();
			var route = jQuery(this).attr("data-route");

			if (String(row) != "undefined" && route) {
				p._renderModal(route.replace("#", row.id));
			} else {
				o.alert._warning("Selecione um registro.");
			}
		});
	};

	p._eventDelete = function () {
		var o = this;
		jQuery("body").delegate("[id=btn-delete]", "click", function () {
			var row = window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()].row(".selected").data();
			var route = jQuery(this).attr("data-route");

			if (String(row) != "undefined" && route) {
				bootbox.confirm({
					closeButton: false,
					message: "<p style='padding: 15px'><strong>" + Lang.get("msg.delete") + "<strong></p>",
					buttons: {
						confirm: {
							label: "Confirmar",
							className: "btn btn-primary btn-raised",
						},
						cancel: {
							label: "Cancelar",
							className: "btn btn-default btn-raised",
						},
					},
					callback: function (result) {
						if (result) {
							o.app._ajax(
								"GET",
								route.replace("#", row.id),
								{},
								function (data) {
									o.alert._success(data.msg);

									if (
										typeof window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()] !== "undefined" &&
										(typeof data.datatableReload === "undefined" || data.datatableReload == true)
									) {
										window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()].ajax.reload();
									}

									if (typeof data.execFunction != "undefined") {
										gpssat.App._functions[gpssat.AppPage._tabsActionId][data.execFunction]();
									}

									if (data.callback != "undefined") {
										eval(data.callback);
									}
								},
								function (data) {
									var response = jQuery.parseJSON(data.responseText);
									switch (response.code) {
										case "23503":
											o.alert._warning("Registro com relacionamento não pode ser excluído.");
											break;
										default:
											o.alert._error(response.msg);
									}
								},
							);
						}
					},
				});
			} else {
				o.alert._warning("Selecione um registro.");
			}
		});
	};

	p._eventGeneric = function () {
		var o = this;
		jQuery("body").delegate("[id^=btn-generic]", "click", function () {
			var route = jQuery(this).attr("data-route");

			var modalId = "";
			if (jQuery(this).attr("data-modal-id")) {
				modalId = jQuery(this).attr("data-modal-id");
			}

			if (
				typeof window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()] !== "undefined" &&
				jQuery(this).attr("data-simple-modal") != "true"
			) {
				var row = window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()].row(".selected").data();
				if (typeof row == "undefined") {
					o.alert._warning("Selecione um registro.");

					return;
				}
			}

			if (String(row) != "undefined" && route) {
				if (jQuery(this).attr("data-new-window") == "true") {
					jQuery("#loading").fadeOut("slow", function () {
						jQuery("#loading").css("display", "none");
					});
					window.open(window.location.origin + "/" + route.replace("#", row.id), "_blank");

					return false;
				}

				if (jQuery(this).attr("data-modal") == "true") {
					p._renderModal(route.replace("#", row.id), modalId);
				} else {
					if (jQuery(this).attr("data-ajax") == true) {
						o.app._ajax(
							"GET",
							window.location.origin + "/" + route.replace("#", row.id),
							false,
							function (data) {
								o.alert._success(data.msg);
							},
							function (data) {
								o.alert._error(data.msg);
							},
						);
					} else {
						o._openPageAjax(route.replace("#", row.id), jQuery(this).attr("data-tool-id"), null, true);
					}
				}
			} else {
				p._renderModal(window.location.origin + "/" + route, modalId);
			}
		});
	};

	p._eventRefresh = function () {
		jQuery("body").delegate("[id^=btn-refresh]", "click", function () {
			var card = jQuery(".card");
			window.gpssat.AppCard.addCardLoader(card);
			if (typeof window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()] !== "undefined") {
				window.gpssat.AppTable._tables[window.gpssat.AppTable._getTableId()].ajax.reload();
			}
			window.gpssat.AppCard.removeCardLoader(card);
		});
	};

	p._eventCollapse = function () {
		jQuery(".card-head .tools #btn-collapse").on("click", function (e) {
			var card = $(e.currentTarget).closest(".card");
			window.gpssat.AppCard.toggleCardCollapse(card);
		});
	};

	p._eventOpenPage = function () {
		var o = this;
		jQuery("body").delegate("[id^=btn-open-page]", "click", function () {
			var route = jQuery(this).attr("data-route");

			o._openPageAjax(route, jQuery(this).attr("data-tool-id"), null, true);
			bootbox.hideAll();
		});
	};

	p._eventMenu = function () {
		var o = this;
		jQuery("[id=main-menu-sub]").on("click", function (e) {
			var route = jQuery(this).attr("href");
			var position = $(".order:last").attr("data-position");

			if (position == undefined) {
				position = 0;
			}

			document.body.classList.remove("menubar-visible");
			//alert(position);
			if (jQuery(this).attr("data-simple-modal") == "true") {
				p._renderModal(route);
			} else {
				//CREATE TAB === 1, PORQUE BOOLEAN VEM COMO 1 DO BD
				o._openPageAjax(
					route,
					jQuery(this).attr("data-tool-id"),
					parseInt(position) + 1,
					true,
					$(this).attr("data-create") === "1" || $(this).attr("data-create") === "true",
				);
			}

			return false;
		});
	};

	p._setPrefixTable = function (newId) {
		var o = this;
		var prefix = jQuery('[data-content="' + newId + '"] .active table').attr("data-prefix");
		if (prefix) {
			o.tables._setPrefix(prefix);
		} else {
			o.tables._setPrefix("");
		}
	};

	p._setTitlePage = function () {
		var o = this;
		document.title = capitalizeWords(jQuery("a#tabs-pages-" + o._tabsActionId).text());
	};

	p._setPageAnalitycs = function () {
		var o = this;
		ga("send", "pageview", {
			page: "/" + jQuery("a#tabs-pages-" + o._tabsActionId).attr("data-route"),
			title: capitalizeWords(jQuery("a#tabs-pages-" + o._tabsActionId).text()),
		});
	};

	p._renderModal = function (route, modalId, data, type) {
		var o = this;
		o.app._ajax(
			type ? type : "GET",
			route,
			data ? data : false,
			function (data) {
				bootbox
					.dialog({
						title: capitalizeWords(data.title),
						message: data.html,
						className: "modal80",
					})
					.off("shown.bs.modal");
			},
			function () {},
		);
	};

	//carregar abas
	p.openTabs = function (position, route, pageId, title) {
		var o = this;

		if (o._tabsId.includes(pageId)) return o._selectPage("tabs-pages-" + pageId, "tabs-pages-" + o._tabsActionId);

		var tabAction = jQuery("#tabs-pages li").length >= 2;
		if (!tabAction) o._tabsActionId = pageId;

		o._tabsId.push(pageId);

		jQuery("#tabs-pages").append(
			`<li style="z-index: ${100 / position};" data-position='` +
				position +
				`'  class=' order  ` +
				(!tabAction ? `active` : ``) +
				`'><a id='tabs-pages-` +
				pageId +
				`' data-id='` +
				pageId +
				`' data-route='` +
				route +
				`'>` +
				capitalizeWords(title) +
				`&nbsp;<i id='tabs-pages-delete-` +
				pageId +
				`' class='closeTab icon-IconBCloseTabs-48'></i></a></li>`,
		);
	};

	p.renderHTML = function ({ $target, HTML, clearBeforeRendering = false }) {
		const $targetNormalizedAsJquery = $($target);
		if (clearBeforeRendering) return $targetNormalizedAsJquery.html(HTML);
		$targetNormalizedAsJquery.append(HTML);
	};

	//carregar conteudo
	p._openPageAjax = function (route, toolId, position, menu, createTab = true) {
		var o = this;
		const pageIdAlreadyRegisteredForThisRoute = p._routesPageId[route];
		if (pageIdAlreadyRegisteredForThisRoute)
			return o._selectPage(`tabs-pages-${pageIdAlreadyRegisteredForThisRoute}`, `tabs-pages-${o._tabsActionId}`);

		o.app._ajax(
			"GET",
			window.location.origin + "/" + route,
			false,
			function (data) {
				if (position == null) {
					position = $(".order:last").attr("data-position");
					if (position == undefined) {
						position = 0;
					} else {
						position = parseInt(position) + 1;
					}
				}
				p._routesPageId[route] = data.pageId;
				const tabId = `tabs-pages-${data.pageId}`;

				const pageTitle = capitalizeWords(data.title);

				const tabWasAlreadyOnTabsList = o._tabsIdView.includes(data.pageId);
				if (tabWasAlreadyOnTabsList) return o._selectPage(tabId, `tabs-pages-${o._tabsActionId}`);

				if (createTab) {
					o._tabsIdView.push(data.pageId);
					o.openTabs(parseInt(position), route, data.pageId, pageTitle);
				}

				if (!o._tabs) {
					if (!o._initTabs()) {
						o.alert._error("Não foi possível carregar a página.<br> Contate o suporte.");
					}
				}

				var tabAction = jQuery("#tabs-pages li").length >= 2;

				if (!tabAction) {
					o._tabsActionId = data.pageId;
				}

				try {
					if (!gpssat.App._variables[data.pageId]) gpssat.App._variables[data.pageId] = [];
					if (!gpssat.App._functions[data.pageId]) gpssat.App._functions[data.pageId] = [];
					if (gpssat.App._functions[data.pageId]) {
						if (!gpssat.App._functions[data.pageId]["onClose"]) gpssat.App._functions[data.pageId]["onClose"] = [];
						if (!gpssat.App._functions[data.pageId]["onChange"]) gpssat.App._functions[data.pageId]["onChange"] = [];
						if (!gpssat.App._functions[data.pageId]["refresh"]) gpssat.App._functions[data.pageId]["refresh"] = [];
					}
					o.renderHTML({ pageId: data.pageId, $target: $("#content-page"), HTML: data.html });
				} catch (error) {
					if (!window.PageRenderErrorRegistry) return console.warn("PagesRuntime: PageRenderErrorRegistry not found.");
					window.PageRenderErrorRegistry.registerByPageId(data.pageId, error);
					console.error(
						`PagesRuntime: An error ocurred during page "${pageTitle}" first rendering: ${error.message}.\n\n* If you wish to have the error thrown for debugging reasons (ex: to get original error callstack) please refer to the global function:\n•\tPageRenderErrorRegistry.throwLatest()`,
					);
				}

				if (typeof data.search != "undefined") {
					o.renderHTML({ pageId: data.pageId, $target: jQuery("#searchBody"), HTML: data.search });
					jQuery(".offcanvas").css("display", "");
					jQuery("[data-content-search=tabs-pages-" + data.pageId + "]").css("display", "");
				}

				if (tabAction && !menu) {
					jQuery("[data-content=tabs-pages-" + data.pageId + "]").css("display", "none");
					jQuery("[data-content-search=tabs-pages-" + data.pageId + "]").css("display", "none");
				} else {
					o._selectPage("tabs-pages-" + data.pageId, "tabs-pages-" + o._tabsActionId);
					o._tabsActionId = data.pageId;
				}

				if (toolId && createTab) {
					o._savePage(data.pageId, route, toolId, position, jQuery("a#tabs-pages-" + data.pageId).text());
				}
				o.toggleTabsScrollOnOverflow();
				gpssat.AppNavigation._ajustBarSetting();

				checkTreeviews(route);
			},
			function (val) {
				if (val.status != 405) {
					o.alert._error("Não foi possível carregar a página.<br> Contate o suporte.");
				}
			},
			null,
			null,
			false,
		);

		return false;
	};

	p._selectPage = function (newId, oldId) {
		var o = this;

		jQuery("[data-content=" + oldId + "]").css("display", "none");
		jQuery("[data-content=" + newId + "]").css("display", "");
		jQuery("[data-content-search=" + oldId + "]").css("display", "none");
		jQuery("[data-content-search=" + newId + "]").css("display", "");

		jQuery("a#" + oldId)
			.parent()
			.removeClass("active");
		jQuery("a#" + newId)
			.parent()
			.addClass("active");
		o._tabsActionId = newId.replace("tabs-pages-", "");
		o._setTitlePage();
		o._setPrefixTable(newId);
		o._setPageAnalitycs();
		Object.keys(window.gpssat.AppMap._map)
			.filter((key) => key.includes(o._tabsActionId))
			.forEach((key) => window.gpssat.AppMap._map[key].invalidateSize());

		if (!gpssat.App._variables[o._tabsActionId]) gpssat.App._variables[o._tabsActionId] = [];
		if (!gpssat.App._functions[o._tabsActionId]) gpssat.App._functions[o._tabsActionId] = [];
		if (gpssat.App._functions[o._tabsActionId]) {
			if (!gpssat.App._functions[o._tabsActionId]["onClose"]) gpssat.App._functions[o._tabsActionId]["onClose"] = [];
			if (!gpssat.App._functions[o._tabsActionId]["onChange"]) gpssat.App._functions[o._tabsActionId]["onChange"] = [];
			if (!gpssat.App._functions[o._tabsActionId]["refresh"]) gpssat.App._functions[o._tabsActionId]["refresh"] = [];
		}
		const onChange = gpssat.App._functions[o._tabsActionId]["onChange"];
		onChange.forEach((onChange) => onChange());
		o.setContentElementHeight();

		//abre perquisa automatica
		/*if (jQuery('[data-content-search=' + newId + ']').attr('data-filter') == 'false') {
			window.gpssat.AppOffcanvas._handleOffcanvasOpen(jQuery('[data-content=' + newId + ']').find("[data-toggle=offcanvas]"));
		}*/
	};

	p._getSizeTabs = function () {
		var sum = 0;
		jQuery(jQuery("ul#tabs-pages li")).each(function (i) {
			if (i > 0) {
				sum += jQuery(this).width();
			}
		});

		return sum;
	};

	p.toggleTabsScrollOnOverflow = function () {
		const $tabsContainer = document.querySelector("#tabs-pages");
		if (!$tabsContainer) throw new Error('"#tabs-pages" selector could not be found.');
		$tabsContainer.classList.add("inspecting");
		const tabsContainerLeftDistance = $tabsContainer.getBoundingClientRect().x;
		const tabsContainerTotalSize = tabsContainerLeftDistance + $tabsContainer.scrollWidth;
		const tabsContainerOverflowed = tabsContainerTotalSize > window.innerWidth;
		$tabsContainer.style.maxWidth = "";
		$tabsContainer.style.maxWidth = `${window.innerWidth - tabsContainerLeftDistance}px`;
		$tabsContainer.classList.remove("inspecting");
		$tabsContainer.classList[tabsContainerOverflowed ? "add" : "remove"]("overflowed");
	};

	p._savePage = function (pageId, url, toolId, position, title) {
		var o = this;
		o.app._ajax("POST", window.location.origin + "/users/tools/store", {
			key: pageId,
			url: url,
			tool_id: toolId,
			x: position,
			title: capitalizeWords(title),
		});
	};

	p._updatePage = function (key, x) {
		var o = this;
		o.app._ajax("POST", window.location.origin + "/users/tools/update", {
			key: key,
			x: x,
		});
	};

	p._deletePage = function (pageId) {
		var o = this;
		o.app._ajax("GET", window.location.origin + "/users/tools/destroy/" + pageId, false, false, false, false);
	};

	p._initPageScrollTop = function () {
		jQuery("#buttonPageScrollTop").on("click", function () {
			jQuery("html, body").animate({ scrollTop: 0 }, "slow");
			return false;
		});

		jQuery(document).on("scroll", function () {
			if (jQuery(document).scrollTop() > 120) {
				jQuery("#buttonPageScrollTop").css("display", "block");
			} else {
				jQuery("#buttonPageScrollTop").css("display", "none");
			}
		});
	};

	p.clearTrevviewCache = function () {
		sessionStorage.removeItem("1.0.0@treeview");
		gpssat.AppMessage._success("Veículos pré-carregados limpos! Próximas abas irão usar veículos atualizados.");
	};

	window.gpssat.AppPage = new AppPage();
})(jQuery);
